var DKMS = window.DKMS || {};

DKMS.MoneyDonation = function() {
    $('#mobile-payment-selector').on('change', function () {
        window.location.href = $(this).val();
    });

    var hasBirthDateInUrl = document.location.search.indexOf('frequency=onetime') > -1;
    console.log(hasBirthDateInUrl);
    if (hasBirthDateInUrl) {
        var value = $('.entity-dkms_life .frequency #id_frequency>li:first-child');
        console.log(value);
        value.addClass("active ");
    }

    $('.directdebit input[name="frequency"]').on('change', function () {
        console.log(this.value);

        var onetime = isNaN(parseInt(this.value)),
            s = $('#sepa-recurring-wording');
        console.log(s);
        s.text(onetime ? s.attr('data-text-onetime') : s.attr('data-text-recurring'));
    });

    $('.country-DE #id_amount').on('change', function () {
        console.log("call amount");
        var show = parseInt($(this).val()) >= 50;
        console.log(show);
        $('.fieldwrapper.donation_receipt').toggle(show);
        if (show === false) {
            $('#id_donation_receipt').prop('checked', false);
        }
    }).trigger('change');


    // disable these fields in germany until the user chooses as how is made the donation
    var disabledParametersGermany = ['#id_salutation_0', '#id_salutation_1', '#id_title', '#id_firstname', '#id_lastname',
        '#id_iban', '#id_street', '#id_houseno', '#id_zipcode', '#id_city', '#id_email', '#id_donation_receipt'];


    for(var iter = 0; iter < disabledParametersGermany.length; iter++) {
        $('.country-DE .directdebit ' + disabledParametersGermany[iter]).prop('disabled', true);
        $('.country-DE .creditcard ' + disabledParametersGermany[iter]).prop('disabled', true);
    }

    /*
    In directdebit DE field company hidden or shown depending on selection field
    to give private or company. Modify field positions in the list
    */
    $('.fieldwrapper.company').addClass('hidden');
    $('.country-DE .directdebit .fielddecorator.salutation__before').addClass('hidden');
    $('.country-DE .directdebit #id_private_company').on('change', function() {

        //enable all fields, independently of which option has been chosen
        for(var iter = 0; iter < disabledParametersGermany.length; iter++) {
            $('.country-DE .directdebit ' + disabledParametersGermany[iter]).prop('disabled', false);
        }

        if (this.value === 'private') {
            $('.fieldwrapper.company').addClass('hidden');
            $('.fielddecorator.salutation__before').addClass('hidden');

            $('.fieldwrapper.iban').insertAfter('.fieldwrapper.lastname');
            $('.fieldwrapper.street').insertAfter('.fieldwrapper.iban');
            $('.fieldwrapper.houseno').insertAfter('.fieldwrapper.street');
            $('.fieldwrapper.zipcode').insertAfter('.fieldwrapper.houseno');
            $('.fieldwrapper.city').insertAfter('.fieldwrapper.zipcode');
            $('.fieldwrapper.email').insertAfter('.fieldwrapper.city');

            $('#id_company').removeAttr('required');
            $('.fieldwrapper.company').removeClass('required');
        }
        else if (this.value === 'company') {
            $('.fieldwrapper.company').removeClass('hidden');
            $('.fieldwrapper.iban').insertBefore('.fieldwrapper.salutation');
            $('.fieldwrapper.street').insertBefore('.fieldwrapper.salutation');
            $('.fieldwrapper.houseno').insertBefore('.fieldwrapper.salutation');
            $('.fieldwrapper.zipcode').insertBefore('.fieldwrapper.salutation');
            $('.fieldwrapper.city').insertBefore('.fieldwrapper.salutation');
            $('.fielddecorator.salutation__before').insertBefore('.fieldwrapper.salutation');
            $('.fielddecorator.salutation__before').removeClass('hidden');

            $('#id_company').attr('required', 'required');
            $('.fieldwrapper.company').addClass('required');
        }
    });

    /*
    in creditcard DE add contact label on choosing type of donation
    rearrange position of fields
    */
    $('.country-DE .creditcard .fielddecorator.salutation__before').addClass('hidden');
    $('.country-DE .creditcard #id_private_company').on('change', function() {

        //enable all fields, independently of which option has been chosen
        for(var iter = 0; iter < disabledParametersGermany.length; iter++) {
            $('.country-DE .creditcard ' + disabledParametersGermany[iter]).prop('disabled', false);
        }
        if (this.value === 'private') {
            $('#id_company').removeAttr('required');
            $('.fieldwrapper.company').addClass('hidden');
            $('.fieldwrapper.company').removeClass('required');
            $('.country-DE .creditcard .fielddecorator.salutation__before').addClass('hidden');

            $('.fieldwrapper.street').insertAfter('.fieldwrapper.lastname');
            $('.fieldwrapper.houseno').insertAfter('.fieldwrapper.street');
            $('.fieldwrapper.zipcode').insertAfter('.fieldwrapper.houseno');
            $('.fieldwrapper.city').insertAfter('.fieldwrapper.zipcode');
        }
        else if (this.value === 'company') {
            $('.country-DE .creditcard .fielddecorator.salutation__before').removeClass('hidden');
            $('.fieldwrapper.company').addClass('required');
            $('.fieldwrapper.company').removeClass('hidden');
            $('#id_company').attr('required', 'required');

            $('.fieldwrapper.street').insertAfter('.fieldwrapper.company');
            $('.fieldwrapper.houseno').insertAfter('.fieldwrapper.street');
            $('.fieldwrapper.zipcode').insertAfter('.fieldwrapper.houseno');
            $('.fieldwrapper.city').insertAfter('.fieldwrapper.zipcode');
        }
    });


    if (typeof Parsley !== 'undefined') {
        Parsley.addValidator('luhn',
            function (value) {
                var val = value.replace(/[ -]/g, '');
                var digit, n, sum, _j, _len1, _ref2;
                sum = 0;
                _ref2 = val.split('').reverse();
                for (n = _j = 0, _len1 = _ref2.length; _j < _len1; n = ++_j) {
                    digit = _ref2[n];
                    digit = +digit;
                    if (n % 2) {
                        digit *= 2;
                        if (digit < 10) {
                            sum += digit;
                        } else {
                            sum += digit - 9;
                        }
                    } else {
                        sum += digit;
                    }
                }
                return sum % 10 === 0;
            }, 32);
    }

    // New PayPal checkout integration
    (function () {
        var form = $('form#md_paypal'),
            client = {},
            conf = window.DKMS.PAYPAL_SETTINGS,
            paypalActions = null;

        if (!form.length || !conf) {
            return;
        }

        client[conf.env] = conf.client_id;

        paypal.Button.render({
            env: conf.env,

            commit: true,

            locale: conf.locale,

            style: {
                label: 'paypal',
                size: 'responsive',    // small | medium | large | responsive
                shape: 'rect',          // pill | rect
                color: 'blue',          // gold | blue | silver | black
                tagline: false
            },

            client: client,

            payment: function () {
                var payment_data = {
                    cc: window.DKMS.COUNTRY_CODE,
                    entity: window.DKMS.ENTITY,
                    total: parseFloat($('#id_amount').val() || 1.0),
                    currency: $('#id_currency').val(),
                    recaptchaResponse: $('#g-recaptcha-response').val()
                };

                return paypal.request.post('/api/paypal/payment/create', payment_data).then(function (rsp) {
                    return rsp.id;
                });
            },

            validate: function(actions) {
                actions.disable();

                form.find('[required]').each(function(idx, elem) {
                    $(elem).parsley().on('field:success', function () {
                        if (form.parsley().isValid()) {
                            actions.enable();
                        }
                    });
                    $(elem).parsley().on('field:error', function () {
                        if (!form.parsley().isValid()) {
                            actions.disable();
                        }
                    });
                });

                form.parsley().on('form:success', function() {
                    console.log('valid form');
                    actions.enable();
                });
            },

            onClick: function() {
                form.parsley().validate();
            },

            onAuthorize: function(pp_data) {
                var data = {};
                $(form.serializeArray()).each(function() {
                    data[this.name] = this.value;
                });

                $.extend(data, pp_data, {
                    cc: window.DKMS.COUNTRY_CODE,
                    entity: window.DKMS.ENTITY
                });

                return paypal.request.post('/api/paypal/payment/execute', data).then(function (rsp) {
                    window.location.href = rsp.location;
                });
            },

            onCancel: function (_data, _actions) {
            },

            onError: function (err) {
                Sentry.captureException(err);
            }
        }, '#paypal-button');
    })();

    // Generic Adyen dropIn/Component payment handler
    var makePayment = function (dropInData, data) {
        data = data || {};

        data._variant = window.DKMS.VARIANT;
        data._language = window.DKMS.LANGUAGE.substr(0, 2);
        data._country = window.DKMS.COUNTRY_CODE;
        data._entity = window.DKMS.ENTITY;

        data.dropInData = dropInData;

        return $.ajax('/api/adyen/payment', {
            data: JSON.stringify(data),
            contentType: 'application/json',
            type: 'POST'
        });
    };

    // Google Pay Integration
    (function () {
        var form = $('form#md_googlepay'),
            conf = window.DKMS.GOOGLEPAY_SETTINGS,
            container = $('#googlepay-container').get(0)
            ;

        if (!form.length || !conf || !container) {
            return;
        }

        var paymentState,
            isTest = conf.adyenPlatform == 'test',
            configuration = {
                locale: window.DKMS.LOCALE,
                originKey: conf.adyenOriginKey,
                environment: conf.adyenPlatform,
                paymentMethodsResponse: conf.paymentMethodsResponse,
                onChange: function (state, _component) {
                    // store payment state, payment is made in googlepay's onAuthorized
                    paymentState = state;
                },
                onError: function (error) {
                    console.error(error);
                }
            },
            checkout = new AdyenCheckout(configuration),
            googlepay = null
        ;

        function createGooglePay() {
            var value = parseFloat($('#id_amount').val()) * 100;
            googlepay = checkout.create('paywithgoogle', {
                // @see https://docs.adyen.com/payment-methods/google-pay/web-component
                environment: isTest ? 'TEST' : 'PRODUCTION',
                amount: {
                    currency: $('#id_currency').val(),
                    value: value
                },
                configuration: {
                    gatewayMerchantId: conf.gatewayMerchantId,                  // Your Adyen merchant or company account name
                    merchantName: conf.merchantName,                            // Optional. The name that appears in the payment sheet.
                    merchantIdentifier: conf.merchantIdentifier || undefined,   // Required for PRODUCTION. Remove this object in TEST. Your Google Merchant ID as described in https://developers.google.com/pay/api/web/guides/test-and-deploy/deploy-production-environment#obtain-your-merchantID
                },
                emailRequired: true,
                billingAddressRequired: true,
                billingAddressParameters: {
                    format: 'FULL'
                },
                onAuthorized: function (data) {
                    if (paymentState.isValid === true) {
                        var formData = {};
                        form.serializeArray().map(function (f) {
                            formData[f.name] = f.value;
                        });

                        var ba = data.paymentMethodData.info.billingAddress;
                        formData.billingAddress = {
                            country: ba.countryCode,
                            city: ba.locality,
                            street: ba.address1,
                            houseNumberOrName: ba.address2,
                            stateOrProvince: ba.administrativeArea,
                            postalCode: ba.postalCode
                        };

                        var name = ba.name.split(' ');
                        formData.shopperEmail = data.email;
                        formData.shopperName = {
                            gender: 'UNKNOWN',
                            lastName: name.pop(),
                            firstName: name.join(' ')
                        };

                        makePayment(paymentState.data, formData)
                            .then(function (rsp) {
                                if (rsp.resultCode == 'Authorised' && conf.successUrl) {
                                    window.location.href = conf.successUrl;
                                }
                            })
                            .catch(function (result) {
                                console.error(result);
                            });
                    }
                }
            });

            return googlepay;
        }

        function mountGooglePay() {
            $('body').addClass('googlepay-available');

            var
                hintNoAmount = $('#hint-no-amount').hide(),
                hintDonateAmount = $('#hint-donate-amount').hide();

            $('#id_amount').on('keyup change blur', function () {
                var valid = $(this).val().match(/^\d+$/);

                if (valid) {
                    googlepay = createGooglePay()
                    googlepay.mount(container);
                    var btn = $('.adyen-checkout__paywithgoogle>div>button');

                    btn.removeClass('disabled').removeAttr('disabled');
                    hintNoAmount.hide();
                    hintDonateAmount.children('span').html($(this).val());
                    hintDonateAmount.show();
                } else {
                    var btn = $('.adyen-checkout__paywithgoogle>div>button');
                    btn.addClass('disabled').attr('disabled', 'disabled');
                    hintNoAmount.show();
                    hintDonateAmount.hide();
                }
            }).trigger('change');
        }

        return mountGooglePay();

        /* do not use isAvailable() for now because it does not work reliably on Safari,
           seems to be an Adyen issue, support ticket was raised on 2020-04-17,
           still not fixed with 3.13.0 as of 2020-09-18 */
        /*
        googlepay.isAvailable().then(mountGooglePay).catch(function (e) {
            console.error(e);
            $('body').removeClass('googlepay-available');
        });
        */
    })();

    // Apple Pay Integration
    (function () {
        var form = $('form#md_applepay'),
            conf = window.DKMS.APPLEPAY_SETTINGS,
            container = $('#applepay-container').get(0)
            ;

        if (!form.length || !conf || !container) {
            return;
        }

        var configuration = {
                locale: window.DKMS.LOCALE,
                originKey: conf.adyenOriginKey,
                environment: conf.adyenPlatform,
                paymentMethodsResponse: conf.paymentMethodsResponse,
                onError: function (error) {
                    console.error(error);
                }
            },
            checkout = new AdyenCheckout(configuration),
            applepay = null
            ;

        function createApplePay(amount) {
            var paymentState;

            return checkout.create('applepay', {
                // @see https://docs.adyen.com/payment-methods/apple-pay/web-component
                currencyCode: $('#id_currency').val(),
                amount: parseInt(amount) * 100, // Adyen micro-units required
                countryCode: window.DKMS.COUNTRY_CODE,
                buttonType: 'donate',
                requiredShippingContactFields: ['email', 'name', 'postalAddress'],
                totalPriceStatus: 'final',
                totalPriceLabel: conf.merchantName,
                configuration: {
                    merchantIdentifier: conf.merchantIdentifier,    // Apple Merchant ID
                    merchantName: conf.merchantName                 // Optional. The name that appears in the payment sheet.
                },
                onSubmit: function (state, _component) {
                    paymentState = state;
                },
                onAuthorized: function (resolve, reject, event) {
                    console.log('onAuthorized', arguments);

                    if (paymentState.isValid === true) {
                        var formData = {};
                        form.serializeArray().map(function (f) {
                            formData[f.name] = f.value;
                        });

                        var a = event.payment.shippingContact;
                        formData.billingAddress = {
                            country: a.countryCode,
                            city: a.locality,
                            street: a.addressLines[0],
                            houseNumberOrName: a.addressLines.length > 1 ? a.addressLines[1] : '',
                            stateOrProvince: a.administrativeArea,
                            postalCode: a.postalCode
                        };

                        formData.shopperName = {
                            gender: 'UNKNOWN',
                            lastName: a.familyName,
                            firstName: a.givenName
                        };

                        formData.shopperEmail = a.emailAddress; // emailAddress is only available in shipping, not billing address

                        makePayment(paymentState.data, formData)
                            .then(function (rsp) {
                                if (rsp.resultCode === 'Authorised') {
                                    resolve({
                                        status: 'STATUS_SUCCESS'
                                    });

                                    if (conf.successUrl) {
                                        window.location.href = conf.successUrl;
                                    }
                                } else {
                                    console.error(rsp);
                                    reject({
                                        status: 'STATUS_FAILURE'
                                    });
                                }
                            })
                            .catch(function (result) {
                                console.error(result);
                                reject({
                                    status: 'STATUS_FAILURE'
                                });
                            });

                    }
                },
                onValidateMerchant: function (resolve, reject, validationURL) {
                    console.log(arguments);
                    $.ajax('/api/adyen/apValidateMerchant', {
                        data: JSON.stringify({
                            _entity: window.DKMS.ENTITY,
                            validationURL: validationURL
                        }),
                        contentType: 'application/json',
                        type: 'POST'
                    }).then(function (paymentSession) {
                        console.log('Apple Pay Payment session', paymentSession, resolve);
                        resolve(paymentSession);
                    }).catch(function (e) {
                        console.error(e);
                        reject(e);
                    });
                }
            });
        }

        $('#id_amount').on('keyup change blur', function () {
            var amount = $(this).val();

            if (applepay) {
                applepay.unmount();
                applepay = null;
            }

            applepay = createApplePay(amount);
            applepay.isAvailable().then(function () {
                $('body').addClass('applepay-available');
                $(form).parsley().validate();

                if (amount.match(/^\d+$/)) {
                    applepay.mount(container);
                } else {
                    applepay.unmount();
                    applepay = null;
                }
            }).catch(function (e) {
                $('body').removeClass('applepay-available');
                console.error(e);
            });
        }).trigger('change');
    })();
};

$(function() {
    new DKMS.MoneyDonation();
    new DKMS.ButtonGroup('.package-moneydonation #id_frequency');
});
